import { useQuery } from "react-query";
import { getInvoiceDebitAdjustment } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetInvoiceDebitAdjustment = () => {
  return useQuery("GetInvoiceDebitAdjustment", getInvoiceDebitAdjustment, {
    refetchOnWindowFocus: false,
  });
};
